
/**
 * Find the intersection of two arrays of scalar values. 
 */
export function arraysIntersect<T = unknown>(a: T[], b: T[]): T[] {
    const longest = a.length > b.length ? a : b;
    const shortest = a.length > b.length ? b : a;
    // iterate over the largest possible set in the outer loop so no values are missed
    // check the shortest in the inner loop. 
    const shared = longest.filter(i => shortest.includes(i));
    // deduplicate by removing matching items that aren't in the first found index.
    // TODO: Could we remove deduplication? It would be nice, especially if we know 
    // the source arrays do no have duplicates. 
    const deduplicated = shared.filter((val, idx, arr) => arr.indexOf(val) === idx);
    return deduplicated;
}